import { createSlice } from '@reduxjs/toolkit';
import { getProjects } from 'ducks/projects/operators';
import { normalizeProjects } from 'ducks/projects/utils';
import { Slices } from 'ducks/slices';
import { ProjectItem } from 'ducks/types/store-types';
import { WithUUID } from 'ducks/types/type-helpers';

export type ProjectsState = WithUUID<ProjectItem>[];
const initialState: ProjectsState = [];

const projectsSlice = createSlice({
  name: Slices.PROJECTS,
  initialState,
  reducers: {
    clearProjects: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProjects.pending, () => {
        return initialState;
      })
      .addCase(getProjects.fulfilled, (_, { payload }) => {
        return normalizeProjects(payload);
      })
      .addCase(getProjects.rejected, () => {
        return initialState;
      });
  },
});

export const { clearProjects } = projectsSlice.actions;

export default projectsSlice.reducer;
